import { render } from "./BlogTypes.vue?vue&type=template&id=1618a0be&scoped=true"
import script from "./BlogTypes.vue?vue&type=script&lang=js"
export * from "./BlogTypes.vue?vue&type=script&lang=js"

import "./BlogTypes.vue?vue&type=style&index=0&id=1618a0be&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1618a0be"]])

export default __exports__